import { useState } from "react";
import * as yup from 'yup';

const useHandleForm = (submitCallback, performanceProcessList, invalidDataCallback) => {

  const createInitialData = () => {
    const fieldNames = [
      "year",
      "performanceProcess",
      "evaluatedBySelectedCommittee",
      "calibrationCommittee",
    ];

    return fieldNames.reduce((initialData, fieldName) => {
      return ({
        ...initialData,
        [fieldName]: fieldName === 'evaluatedBySelectedCommittee' ? true : ""
      })
    }, {});
  }

  const [formData, setFormData] = useState(createInitialData());

  const dataIsValid = async () => {

    const schema = yup.object().shape({
      year: yup.string().required(),
      performanceProcess: yup.string().required(),
      calibrationCommittee: yup.string().required(),
    });

    return await schema.isValid(formData).then((valid) => valid);
  }

  const performanceProcess = performanceProcessList[formData.year]?.find((item) => item.key === formData.performanceProcess);

  const submit = async () => {
    if (await dataIsValid()) {
      submitCallback({
        ...formData,
        potentialProcess: performanceProcess?.associatedPotentialProcess,
        reinitializeRows: false,
      });
      return true;
    } else {
      invalidDataCallback();
      return false;
    }
  }

  const setFormValue = (value, fieldName) => {
    if (fieldName === "year") {
      setFormData({
        ...formData,
        [fieldName]: value,
        performanceProcess: "",
        potentialProcess: "",
      });
      return;
    }

    setFormData({
      ...formData,
      [fieldName]: value,
    });
  }

  return {
    formData,
    setFormValue,
    submit,
    performanceProcess,
  };
}

export default useHandleForm;